import { render, staticRenderFns } from "./IconMenuReport.vue?vue&type=template&id=71d5fd0e"
import script from "./IconMenuReport.vue?vue&type=script&lang=js"
export * from "./IconMenuReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports